<div class="faq-menu">
  @if (!helpData && !isLoading) {
    <div class="error-container">
      <div class="warning-icon">
        <mat-icon>warning</mat-icon>
      </div>
      <div class="warning-text">
        <p class="top-faq-text">{{ 'faq.no-faq-load-info' | translate }}</p>
        <p>{{ 'faq.reload-page-info' | translate }}</p>
      </div>
    </div>
  }
  @if (!isLoading && helpData) {
    <div class="menu-container">
      <mat-tab-group
        class="main-tab-height"
        [selectedIndex]="generalTabIndex()">
        <mat-tab>
          <mat-tab-group
            class="main-tab-height"
            [selectedIndex]="faqTabIndex()">
            <mat-tab>
              <coin-siemens-energy-faq-top-level
                class="faq-base-tab"
                [items]="helpData"
                (openFaq)="openFaqFromSub($event)"
                (openOther)="onOpenOtherTopic($event)"></coin-siemens-energy-faq-top-level>
            </mat-tab>
            @for (tab of faqTabs(); track tab) {
              <mat-tab>
                @if (tab?.content?.length === 0) {
                  <p class="faq-padding">{{ 'faq.no-items-found' | translate }}</p>
                }
                @if (!tab.isAnswer) {
                  <coin-siemens-energy-faq-inbetween-level
                    class="faq-base-tab"
                    [items]="tab"
                    (openFaq)="openFaqFromSub($event)"></coin-siemens-energy-faq-inbetween-level>
                }
                @if (tab.isAnswer) {
                  <coin-siemens-energy-faq-answer-level
                    class="faq-base-tab"
                    [items]="tab"></coin-siemens-energy-faq-answer-level>
                }
              </mat-tab>
            }
          </mat-tab-group>
        </mat-tab>
      </mat-tab-group>
    </div>
  } @else {
    @if (isLoading) {
      <div class="loading-container">
        <v2-turbine
          [contrast]="true"
          [withPole]="true" />
      </div>
    }
  }
  <div>
    <ng-template #loading>
      @if (isLoading) {
        <div class="loading-container">
          <v2-turbine
            [contrast]="true"
            [withPole]="true" />
        </div>
      }
    </ng-template>
  </div>
</div>
